import { FC } from 'react';
import { Content } from '@prismicio/client';
import { JSXMapSerializer, PrismicRichText } from '@prismicio/react';

import { TableHead } from '@/components';
import { Simplify } from '../../../prismicio-types';
import { TableContentVariant } from '@/types';

import styles from './californiaPolicyTable.module.scss';

const headComponents = (variant: TableContentVariant): JSXMapSerializer => ({
  paragraph: ({ children }) => (
    <p className={`${styles.headText} ${styles[variant]}`}>{children}</p>
  ),
});

type Props = {
  data: Simplify<Content.PolicyTableSliceCaliforniaPolicyPrimary>;
  variant: TableContentVariant;
};

export const CaliforniaHead: FC<Props> = ({ data, variant }) => {
  return (
    <TableHead className={styles.head}>
      {data.head.map((item, index) => (
        <PrismicRichText
          field={item.title}
          key={`${item.title[0]?.type}-${index}`}
          components={headComponents(variant)}
        />
      ))}
    </TableHead>
  );
};
